import API from '../../utils/Api'
import i18n from '@/plugins/i18n'

const api = new API('companies-settings')


const state = {
  list: [],
  loading: false,
  model: {
    name: "",
    level: 0,
    suppliers: [],
    clients: [],
    leadTime: 1,
    productionLeadTime: 1,
    initialStock: 12,
    firstOrder: 4,
    firstProduction: 4,
    ddOn: false,
    simulatedCompany: false,
    productionCompany: false,
    demandProfile: null,
    assemblyMode: false
  }
}

const getters = {
  headers () {
    return [
      {
        text: i18n.t('companiesSettings.level'),
        align: 'center',
        value: 'level'
      },
      {
        text: i18n.t('companiesSettings.name'),
        align: 'center',
        value: 'name'
      },
      {
        text: i18n.t('companiesSettings.ddOn'),
        align: 'center',
        value: 'dd'
      },
      {
        text: i18n.t('companiesSettings.simulatedCompany'),
        align: 'center',
        value: 'type'
      },
      {
        text: i18n.t('companiesSettings.logo'),
        align: 'center',
        value: 'logo',
        sortable: false,
        img: true
      },
      {
        text: i18n.t('general.actions'),
        align: 'center',
        sortable: false
      }
    ]
  }
}

const actions = {
  async getOne({ commit }, id) {
    try {
      commit('SET_loading', true)
      let res = await api.get(id)
      commit('SET_loading', false)
      return res.data
    } catch (error) {
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.companiesSettings.getOneError') + error.message }, { root: true })
    }
  },
  async getAll({ commit }, gameVersion) {
    try {
      commit('SET_loading', true)
      let res = await api.getAll({gameVersion: gameVersion})
      commit('SET_list', res.data)
      commit('SET_loading', false)
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.companiesSettings.getAllError') + error.message }, { root: true })
    }
  },
  async add({ commit }, data) {
    try {
      commit('SET_loading', true)
      let res = await api.post(data, '')
      commit('ADD_list', res.data)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('notifications.companiesSettings.add') }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.companiesSettings.addError') + error.message }, { root: true })
      return false
    }
  },
  async update({ commit }, params) {
    try {
      commit('SET_loading', true)
      let res = await api.put(params.id, params.data, "")
      commit('UPDATE_list', res.data)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('notifications.companiesSettings.update') }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.companiesSettings.updateError') + error.message }, { root: true })
      return false
    }
  },
  async uploadLogo({ commit }, params) {
    try {
      commit('SET_loading', true)
      let res = await api.upload(params.id, params.data, 'update-logo')
      commit('UPDATE_list', res.data)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: "Le logo a bien été modifié" }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: "Erreur lors de la modification du logo : " + error.message }, { root: true })
      return false
    }
  },
  async uploadSupplyPicture({ commit }, params) {
    try {
      commit('SET_loading', true)
      let res = await api.upload(params.id, params.data, 'update-supply-picture')
      commit('UPDATE_list', res.data)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: "Le logo a bien été modifié" }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: "Erreur lors de la modification du logo : " + error.message }, { root: true })
      return false
    }
  },
  async delete({ commit }, params) {
    try {
      commit('SET_loading', true)
      await api.deleteMany(params)
      commit('DELETE_list', params)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('notifications.companiesSettings.delete') }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.companiesSettings.deleteError') + error.message }, { root: true })
      return false
    }
  }
}

const mutations = {
  DELETE_list(state, toDelete) {
    for (let i = 0; i < toDelete.length; i++) {
      for (let index = 0; index < state.list.length; index++) {
        if (state.list[index]._id === toDelete[i]) {
          state.list.splice(index, 1)
          break
        }
      }
    }
    
  },
  UPDATE_list(state, val) {
    for (let index = 0; index < state.list.length; index++) {
      if (state.list[index]._id === val._id) {
        state.list.splice(index, 1, val)
        break
      }
    }
  },
  ADD_list(state, val) {
    state.list.push(val)
  },
  SET_list(state, val) {
    state.list = val
  },
  SET_loading(state, val) {
    state.loading = val
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}